<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <section id="brand-section" class="mobile-container bg-color-pink" style="background-color: #E362A0;">
            <div class="d-flex align-items-center justify-content-between position-relative">
                <div style="width: 100%;">
                    <!-- TrustBox widget - Micro TrustScore -->
                    <div class="trustpilot-widget"
                         data-locale="da-DK"
                         data-template-id="5419b637fa0340045cd0c936"
                         data-businessunit-id="5cca9a854786990001506c0e"
                         data-style-height="25px"
                         data-style-width="100%"
                         data-theme="dark"
                    >
                        <a href="https://dk.trustpilot.com/review/steptransport.dk" target="_blank" rel="noopener">
                            Trustpilot
                        </a>
                    </div>
                    <!-- End TrustBox widget -->
                </div>
            </div>
        </section>
        <section id="text-section" class="mobile-container bg-light">
            <div class="py-2">
                <div class="mb-2">Kære {{ booking.pickup_address.name.replace(/\s.*/, '') }},</div>

                <div v-if="!expiredLink">
                    <div class="mb-2">Vi har fået æren af at afhente din returnering fra {{ booking.client.name }}.</div>
                    <div class="mb-2" v-if="booking.pickup_end && !isSms1">
                        <div v-if="booking.pickup_trip && booking.pickup_trip.time_communicated">
                            Din returnering afhentes den {{ formatDate(booking.pickup_end, 'DD-MM-yyyy') }}
                            <span>
                            mellem kl.
                            {{ getPickupTime(booking, 'start', configurations['default_time_from_pickup'].value) }} -
                            {{ getPickupTime(booking, 'end', configurations['default_time_to_pickup'].value) }}
                        </span>
                        </div>
                    </div>
                    <div class="mb-2" v-else>
                        Imens du venter, har du mulighed for at opgradere dine services for leveringen.
                    </div>
                    <div>
                        <a href="#" @click.prevent="openModalIframe">Har du spørgsmål til din returnering?</a>
                    </div>
                </div>

                <div v-else>
                    <div class="mb-2">
                        <span>
                            Din bestilling fra {{ booking.client.name }} leveres den&nbsp;
                        </span>
                        <span v-if="booking.pickup_end || (booking.pickup_trip && booking.pickup_trip.delivered_end)">
                            {{ formatDate(booking.pickup_end, 'DD-MM-yyyy') }} mellem kl.
                            {{ configurations['default_time_from_pickup'].value }} -
                            {{ configurations['default_time_to_pickup'].value }}.
                        </span>
                    </div>
                    <div class="mb-2 text-danger">
                        Bemærk: Klokken er over
                        {{
                            configurations['sms_flow_cut_off_time_pickup'] && configurations['sms_flow_cut_off_time_pickup']['value'] ?
                            configurations['sms_flow_cut_off_time_pickup']['value'] :
                            ''
                        }}
                        og deadline er overskrevet.
                        Du kan dermed ikke foretage ændringer i din levering.
                    </div>
                </div>
                <div class="text-danger text-center my-3" v-if="error">{{ error }}.</div>
            </div>
        </section>
        <div class="mobile-container text-light font-larger">Afhentningsdato</div>
        <section id="date-section" class="mobile-container bg-light">
            <div class="mb-4">
                <div class="mb-1">Se mulige tilvalg:</div>
                <div class="d-flex mb-1">
                    <input type="checkbox"
                           id="option-variants"
                           v-model="additionalServices[newDeliveryDateKey].enabled"
                    >
                    <label class="ml-2 mb-0" for="option-variants">Vælg en ny afhentningsdato</label>
                </div>

            </div>
            <div class="mb-4" v-if="additionalServices[newDeliveryDateKey].enabled">
                <div class="mb-1">Se mulige tider og priser i kalenderen:</div>
                <div
                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 position-relative">
                    <date-picker
                        manual-input
                        :clearable="true"
                        v-model="additionalServices[newDeliveryDateKey].value" valueType="format"
                        input-class="border-0 py-0 shadow-none form-input"
                        :lang="datePickerOptions.lang"
                        :disabled-date="disabledDates"
                        :formatter="dateFormat"
                        @change="onDateChange"
                        placeholder="dd-mm-yyyy">
                        <template v-slot:icon-clear>
                            <svg></svg>
                        </template>
                        <template v-slot:icon-calendar>
                            <svg></svg>
                        </template>
                    </date-picker>
                    <i class="mx-icon-clear position-absolute" style="top: 18px; right: 12px;" @click="clearNewDate">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
                            <path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z" fill="#843468"></path>
                        </svg>
                    </i>
                </div>
                <div class="text-danger" v-if="errors[newDeliveryDateKey]">
                    {{ errors[newDeliveryDateKey] }}
                </div>
            </div>
            <div>
                <button class="btn btn-success" @click="goNext">Næste STEP</button>
            </div>
        </section>
    </div>

</template>

<script>
import FlashError from "../reusable/FlashError.vue";
import priceMixin from "../../../mixins/priceMixin";
import dateTimeMixin from "../../../mixins/dateTimeMixin";
import moment from "moment/moment";
import customerSmsFlowMixin from "../../../mixins/customerSmsFlowMixin";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import datePickerOptionsMixin from "../../../mixins/datePickerOptionsMixin";
export default {
    name: "CmfPickupStep1",
    components: {FlashError, DatePicker},
    mixins: [priceMixin, dateTimeMixin, customerSmsFlowMixin, datePickerOptionsMixin],
    props: {
        booking: {type: Object, required: true},
        configurations: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        newDeliveryDateKey: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        error: {type: String, required: false, default: ''},
        expiredLink: {type: Boolean, required: true},
        isSms1: {type: Boolean, required: true},
        autopushedDate: {type: String, required: false, default: ''},
        applyChangesUrl: {type: String, required: true},
        routeAvailableDays: {type: Object|Array, required: true},
        futureDaysAddOn: {type: Object, required: false},
        faqUrl: {type: String, required: true},
    },
    data() {
        return {
            show: false,
            isSubmit: false,
            errors: {},
            additionalServices: {},
            prices: {},
            dateFormat: {
                // Date to String
                stringify: (date) => {
                    if (date) {
                        date = moment(date).format('DD-MM-YYYY');
                        return this.prices[date] ?
                            date + ' (' + this.calculatePriceWithVatAndRoundToNearestTens(this.prices[date]) + ' kr.)' :
                            date;
                    }
                    return ''
                },
                // String to Date
                parse: (value) => {
                    if (value && value.includes('(')) {
                        value = value.replace(/\(.*/, '');
                    }
                    return value ? moment(value, 'DD-MM-YYYY').toDate() : null
                },
            },
            firstAvailableDate: moment(this.autopushedDate ? this.autopushedDate : this.booking.pickup_end),
        }
    },
    created() {
        let service = this.additionalServicesProp[this.newDeliveryDateKey] ?
            this.additionalServicesProp[this.newDeliveryDateKey] :
            {
                key: this.newDeliveryDateKey,
                name: 'New pickup date',
                value: '',
                price: 0,
                enabled: false
            };
        this.$set(this.additionalServices, this.newDeliveryDateKey, service);

        let diff = moment().diff(this.firstAvailableDate);
        this.firstAvailableDate = diff < 0 ? this.firstAvailableDate : moment();
        let startDay = this.firstAvailableDate.format('YYYY-MM-DD');

        let dayNumbers = 8 * 7;
        let freeFutureDays = 0;
        if (this.futureDaysAddOn) {
            freeFutureDays = parseInt(this.futureDaysAddOn.configurations['future_days']);
            dayNumbers = parseInt(this.futureDaysAddOn.configurations['want_more']) * 7;
        }

        const costPerDay = parseInt(this.configurations['pickup_cost_for_changed_date']['value']);
        let day;
        for (let i = (freeFutureDays + 1); i <= dayNumbers; i++) {
            day = moment(startDay, 'YYYY-MM-DD').add(i, 'days').format('DD-MM-YYYY');
            this.$set(this.prices, day, (costPerDay * (i - freeFutureDays)));
        }
    },
    methods: {
        disabledDates(date) {
            if (Object.keys(this.routeAvailableDays).length &&
                !Object.keys(this.routeAvailableDays).includes(date.getDay().toString())
            ) {
                return true;
            }

            const startFrom = this.firstAvailableDate.toDate();
            startFrom.setHours(0, 0, 0, 0);

            let disabledInConf = false;
            let disabledDatesConf = (this.configurations.not_available_delivery_dates && this.configurations.not_available_delivery_dates.value) ?
                JSON.parse(this.configurations.not_available_delivery_dates.value) :
                null;
            if (disabledDatesConf && disabledDatesConf.length) {
                disabledInConf = disabledDatesConf.includes(moment(date).format('DD-MM-YYYY'));
            }

            let dayNumbers = 8;
            if (this.futureDaysAddOn) {
                dayNumbers = parseInt(this.futureDaysAddOn.configurations['want_more'])
            }

            return disabledInConf ||
                date < startFrom ||
                date > new Date(startFrom.getTime() + 7 * 24 * 3600 * 1000 * dayNumbers) ||
                [0,6].includes(date.getDay())
        },
        onDateChange(date) {
            if (date.includes('(')) {
                let price = date.replaceAll(/.*\s\(|kr.*/gi, '');
                price = parseInt(price);
                this.$set(this.additionalServices[this.newDeliveryDateKey], 'price', price);
            }
        },
        clearNewDate() {
            this.$set(this.additionalServices[this.newDeliveryDateKey], 'value', '');
        },
        validate() {
            this.errors = {};
            if (this.additionalServices[this.newDeliveryDateKey].enabled &&
                !this.additionalServices[this.newDeliveryDateKey].value
            ) {
                this.$set(this.errors, this.newDeliveryDateKey, 'The value can\'t be empty');
            }
        },
        goNext() {
            this.validate();
            setTimeout(() => {
                if (!Object.keys(this.errors).length) {
                    axios.post(this.applyChangesUrl, this.additionalServices)
                        .then((response) => {
                            window.location.href = this.nextUrl;
                        }).catch(error => {
                        this.$refs.flashError.flashError(error);
                    });
                }
            }, 50);
        },
        getTimeString(type) {
            let timeStr = '';
            if (this.configurations[type] &&
                this.configurations[type]['value']
            ) {
                let hoursMinutes = this.configurations[type]['value'].split(':');
                if (hoursMinutes[0] !== '00') {
                    timeStr += hoursMinutes[0] + ' timer ';
                }

                if (hoursMinutes[1] !== '00') {
                    timeStr += hoursMinutes[1] + ' minutter ';
                }
            }

            return timeStr;
        }
    },
}

</script>

<style scoped>

</style>
